<template>
    <span v-if="hasRegisteredWordClass()">
        <template v-if="getShowLemma()">
            <span v-for="(lemma_header, lemma_index) in norskOrdbank.lemma_list || []"><span v-if="!keyIsFirst(norskOrdbank.lemma_list, lemma_index)">, </span>{{ lemma_header }}</span><br />
        </template>

        <PartOfSpeachHeader
            :snId="snId"
            :norskOrdbank="norskOrdbank"
            :partOfSpeachInfo="partOfSpeachInfo"
        />
    </span>
    <span v-else-if="isOrdbankWordClass(norskOrdbank, 'lexin')">
        <template v-if="getShowLemma()">
            <span v-for="(lemma_header, lemma_index) in norskOrdbank.lemma_list || []"><span v-if="!keyIsFirst(norskOrdbank.lemma_list, lemma_index)">, </span>{{ lemma_header }}</span><br />
        </template>
        <template v-if="hasBoyingPartOfSpeachResultHeader('content')">
            <span v-html="getBoyingPartOfSpeachResultHeaderContent('content')" class="text-lowercase"></span>
            <em v-if="hasBoyingPartOfSpeachResultHeader('content_extra')" class="text-lowercase" v-html="getBoyingPartOfSpeachResultHeaderContent('content_extra')"></em>
        </template>
        <template v-else>
            <span v-html="getBoyingResultHeader()" class="text-lowercase"></span><em v-if="hasBoyingResultSubHeader()" class="text-lowercase"> {{ getBoyingResultSubHeader() }}</em>
        </template>
    </span>
</template>
<script>

import SpeakTextContent from "./SpeakTextContent.vue";
import LexinBoyingResult from "./LexinBoyingResult.vue";
import PartOfSpeachHeader from "./PartOfSpeachHeader.vue";

export default {
	name: 'norskOrdbankResultHeader',
    components: {
        PartOfSpeachHeader,
        SpeakTextContent,
        LexinBoyingResult
    },
    data(){
        return {
            wordClassList: [
                'substantiv',
                'verb',
                'adjektiv',
                'adverb',
                'personlig pronomen',
                'spørrepronomen',
                'determinativ',
                'determinativ possessiv',
                'determinativ demonstrativ',
                'determinativ kvantor',
                'navn',
                'prefiks',
                'refleksivt pronomen',
                'resiprokt pronomen',
                'preposisjon',
                'konjunksjon',
                'subjunksjon',
                'interjeksjon',
                'i sammensetning',
                'forkortelse',
                'symbol',
            ],
        }
    },
	props:{
        'snId': {
            required: false,
            default: () => (0)
        },
        'langCode': {
            required: false,
            default: ''
        },
        'norskOrdbank': {
            required: false,
            default: () => ({})
        },
        'partOfSpeachInfo': {
            required: false,
            default: () => ({})
        },
        'norskOrdbankIndex': {
            required: false,
            default: ''
        },
        'showLemma': {
            required: false,
            default: false
        }
	},
    mounted() {
    },
	methods:{
        hasBoyingPartOfSpeachResultHeader(fieldName = 'content') {
            let value = false;
            if (this.norskOrdbank && this.norskOrdbank.language_code) {
                let snId = this.snId;
                let langCode = this.langCode;

                if (this.partOfSpeachInfo['sn_map'] !== undefined &&
                    this.partOfSpeachInfo['sn_map'][snId] !== undefined &&
                    this.partOfSpeachInfo['sn_map'][snId][langCode] !== undefined &&
                    this.partOfSpeachInfo['sn_map'][snId][langCode][fieldName] !== undefined
                ) {
                    value = true;
                }
            }

            return value;
        },
        getBoyingPartOfSpeachResultHeaderContent(fieldName = 'content') {
            let value = '';
            if (this.norskOrdbank && this.norskOrdbank.language_code) {
                let snId = this.snId;
                let langCode = this.langCode;

                if (this.partOfSpeachInfo['sn_map'] !== undefined &&
                    this.partOfSpeachInfo['sn_map'][snId] !== undefined &&
                    this.partOfSpeachInfo['sn_map'][snId][langCode] !== undefined &&
                    this.partOfSpeachInfo['sn_map'][snId][langCode][fieldName] !== undefined
                ) {
                    value = this.partOfSpeachInfo['sn_map'][snId][langCode][fieldName];
                }
            }

            return value;
        },
        hasRegisteredWordClass() {
            let value = false;
            if (this.norskOrdbank !== undefined &&
                this.norskOrdbank.ordklasse !== undefined &&
                this.wordClassList.includes(this.norskOrdbank.ordklasse)) {
                value = true;
            }

            return value;
        },
        getTranslatedValue(value) {
            if (this.$te(value)) {
                return this.$t(value);
            } else {
                return value;
            }
        },
        getShowLemma() {
            if (this.showLemma == true &&
                this.norskOrdbank != undefined &&
                this.norskOrdbank.lemma_list != undefined) {
                return true;
            }

            return false;
        },
        getBlockSpeakerId(word_index, fieldName) {
            let id = this.getBlockId("ordbank-speaker-id");
            id += "-" + word_index.toString() + "-" + fieldName.toString();

            return id;
        },
        getOrdbankId(norskOrdbank, name) {
            let value = name;

            if (typeof norskOrdbank == "object" && norskOrdbank.lemma_id != undefined) {
                value += "-" + norskOrdbank.lemma_id;
            }

            if (this.norskOrdbankIndex != undefined) {
                value += "-" + this.norskOrdbankIndex;
            }

            return value;
        },
        listLength(list) {
            let value = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = Object.keys(list).length;
            }

            return value;
        },
        isOrdbankWordClass(norskOrdbank, ordklasse) {
            let value = false;
            if (norskOrdbank.ordklasse !== undefined && norskOrdbank.ordklasse === ordklasse) {
                value = true;
            }

            return value;
        },
        getKjoennTranslationCode(kjoenn_header_code) {
            let value = "message.ordbank_kjoenn_" + kjoenn_header_code;

            return value;
        },

        getSubstantivHeader() {
            let value = '';
            if (typeof this.norskOrdbank == "object") {
                if (this.listLength(this.norskOrdbank.list) == 3) {
                    value = this.$t("message.ordbank_kjoenn_mask") + ", " +
                        this.$t("message.ordbank_kjoenn_fem") + " " +
                        this.$t("message.ordbank_or") + " " +
                        this.$t("message.ordbank_kjoenn_noeyt")
                } else if (this.listLength(this.norskOrdbank.list) <= 2) {
                    for (let lang_code in this.norskOrdbank.list) {
                        if (value) {
                            value += " " + this.$t("message.ordbank_or") + " ";
                        }
                        value += this.$t(this.getKjoennTranslationCode(lang_code));
                    }
                }
            }

            return value;
        },

        hasResultRowFields(row, field_list) {
            if (typeof row == "object") {
                for (let i in field_list) {
                    let field_name = field_list[i];
                    if (row[field_name] == undefined) {
                        return false;
                    }
                }
            }
            return true;
        },
        getBoyingResult() {
            let boyingResult = {
                'headers': this.norskOrdbank["headers"] || [],
                'rows': this.norskOrdbank["rows"] || [],
                'header': this.norskOrdbank["header"] || "",
                'sub_header': this.norskOrdbank["sub_header"] || "",
            };

            return boyingResult;
        },
        getBoyingResultHeader() {
            let header = '';
            if (this.$te((this.norskOrdbank["header"] || ""))) {
                header = this.$t((this.norskOrdbank["header"] || ""));
            } else {
                header = (this.norskOrdbank["header"] || "");
            }

            return header;
        },
        hasBoyingResultSubHeader() {
           let value = false;

           if (this.getBoyingResultSubHeader() !== '') {
               value = true;
           }

           return value;
        },
        getBoyingResultSubHeader() {
            let header = '';
            if (this.norskOrdbank.sub_header_list !== undefined && this.norskOrdbank.sub_header_list.length > 0) {
                if (this.listLength(this.norskOrdbank.sub_header_list.length) === 3) {
                    header = this.getTranslatedValue("message.ordbank_kjoenn_mask") + ", " +
                        this.getTranslatedValue("message.ordbank_kjoenn_fem") + " " +
                        this.getTranslatedValue("message.ordbank_or") + " " +
                        this.getTranslatedValue("message.ordbank_kjoenn_noeyt")
                } else if (this.listLength(this.norskOrdbank.sub_header_list.length) <= 2) {
                    for (let i in this.norskOrdbank.sub_header_list) {
                        if (header) {
                            header += " " + this.getTranslatedValue("message.ordbank_or") + " ";
                        }
                        header += this.getTranslatedValue((this.norskOrdbank.sub_header_list[i]));
                    }
                }
            } else if ((this.norskOrdbank["sub_header"] || "")) {
                header = this.getTranslatedValue((this.norskOrdbank["sub_header"] || ""));
            } else if (this.norskOrdbank.headers !== undefined &&
                this.norskOrdbank.headers.headers !== undefined &&
                this.norskOrdbank.headers.headers.sub_header !== undefined &&
                this.norskOrdbank.headers.headers.sub_header) {
                header = this.getTranslatedValue(this.norskOrdbank.headers.headers.sub_header);
            }

            return header;
        },
        getPartOfSpeachHeader(defaultValue = '') {
            let value = '';

            let ordklasse = this.norskOrdbank.ordklasse || '';
            let langCode = '';
            if (this.norskOrdbank.language_code === 'nob') {
                langCode = 'E-N';
            } else if (this.norskOrdbank.language_code === 'nno') {
                langCode = 'Nny';
            }

            if (this.partOfSpeachInfo[langCode] !== undefined &&
                this.partOfSpeachInfo[langCode][ordklasse] !== undefined) {
                value = this.partOfSpeachInfo[langCode][ordklasse].content;
            } else {
                value = defaultValue;
            }

            return value;
        },
        getPartOfSpeachSubHeader(defaultValue = '') {
            let value = '';

            let ordklasse = this.norskOrdbank.ordklasse || '';
            let langCode = '';
            if (this.norskOrdbank.language_code === 'nob') {
                langCode = 'E-N';
            } else if (this.norskOrdbank.language_code === 'nno') {
                langCode = 'Nny';
            }

            if (this.partOfSpeachInfo[langCode] !== undefined &&
                this.partOfSpeachInfo[langCode][ordklasse] !== undefined) {
                value = this.partOfSpeachInfo[langCode][ordklasse].content_extra;
            } else {
                value = defaultValue;
            }

            return value;
        },
        keyIsFirst(objectList, index) {
            let value = false;
            for (let i in objectList) {
                if (parseInt(i) === index) {
                    value = true;
                }
                break;
            }

            return value;
        }
    }
}
</script>
